jQuery(document).ready(function($) {

    function loadRepurchaseDocs(page = 1) {
        if (typeof current_page_id !== "undefined" && current_page_id !== "" && unit_per_page !== "") {
            $.ajax({
                url: localized_object.ajax_url,
                type: "POST",
                data: {
                    action: "load_unit_classes",
                    page: page,
                    page_id: current_page_id,
                    per_page: unit_per_page
                },
                beforeSend: function() {
                    // Add overlay loader
                    if ($("#unit-table .loader-overlay").length === 0) {
                        $("#unit-table").append("<div class='loader-overlay'><div class='spinner'></div></div>");
                    }
                },
                success: function(response) {
                    let data = JSON.parse(response);
                    $("#unit-table").html(data.html);
                    $("#unit-pagination").html(data.pagination);
                },
                complete: function() {
                    // Remove overlay after content loads
                    $("#unit-table .loader-overlay").remove();
                }
            });
        }
    }
    

    // load first page
    loadRepurchaseDocs(1);

    // handle pagination click
    $(document).on("click", ".unit-page", function(e) {
        e.preventDefault();
        const nextPage = $(this).data("page");
        loadRepurchaseDocs(nextPage);
    });
});
